// ASK-139 §82 F-205b — show/hide on a password field (Shaun: "a useful addition to all sign-in
// screens will be the eye icon to see passwords being entered"). The runtime gate's half; GCG's
// console shipped the same control (ASK-144, `probe-signin-form` E1–E8) and this matches its grammar:
// a real <button type="button"> (never submits), 44 × 44 px, `aria-pressed` false → true, the label
// says what a press WILL do ("Show password" / "Hide password"), and the typed value is never touched.
//
// The flip happens IN PLACE on the live input. The gate re-renders its whole form on submit/error,
// and a re-render here would throw away what she typed — the one thing a show-password control is
// for. The gate keeps the shown/hidden state so a re-render draws the field as she left it.
// The two glyphs are inlined rather than imported from `_icons.js`: the gate is in the customer's
// INITIAL bundle, and importing the icon map split a 2.8 KB shared chunk into it (check-bundle-budget,
// measured). Same paths as `_icons.js` `eye` / `eyeOff`, same `kapowx-icon--header` sizing.
const svg = (d) => `<svg class="kapowx-icon kapowx-icon--header" viewBox="0 0 24 24" aria-hidden="true">${d}</svg>`;
const EYE = svg('<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>');
const EYE_OFF = svg('<path d="M2 12s3.5-7 10-7c2 0 3.7.6 5.1 1.5"/><path d="M22 12s-3.5 7-10 7c-2 0-3.7-.6-5.1-1.5"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/><path d="m3 3 18 18"/>');
const icon = (name) => (name === "eyeOff" ? EYE_OFF : EYE);

/** Markup for the toggle. `shown` = the password is currently visible as text. */
export function passwordToggleHtml(shown = false, disabled = false) {
	const label = shown ? "Hide password" : "Show password";
	return `<button class="kapowx-auth-gate__pw-toggle" type="button" data-auth-pw-toggle`
		+ ` aria-pressed="${shown ? "true" : "false"}" aria-label="${label}" title="${label}"`
		+ `${disabled ? " disabled" : ""}>${icon(shown ? "eyeOff" : "eye", "header")}</button>`;
}

/** Flip one field's visibility in place. Returns the new `shown`. Keeps the value, the focus and the
 *  caret where she left them — a toggle that moves the caret to the start makes the next keystroke
 *  land in the wrong place. */
export function togglePasswordVisibility(button, input) {
	if (!button || !input) return false;
	const shown = input.type !== "text";            // the state AFTER this press
	const start = input.selectionStart, end = input.selectionEnd;
	input.type = shown ? "text" : "password";
	button.setAttribute("aria-pressed", shown ? "true" : "false");
	const label = shown ? "Hide password" : "Show password";
	button.setAttribute("aria-label", label);
	button.setAttribute("title", label);
	button.innerHTML = icon(shown ? "eyeOff" : "eye", "header");
	try { if (start != null) input.setSelectionRange(start, end); } catch { /* type=password refuses on some engines */ }
	return shown;
}
